import React from 'react';
import ReactDOM from 'react-dom';
import ComponentBasePrototype from 'ComponentBasePrototype';
import CustomerSupportCard from './customer-support-card-base';

export default class CustomerSupportCardMount extends ComponentBasePrototype {
  build() {
    ReactDOM.render(
      <CustomerSupportCard content={this.data.content} />,
      this.node.get(0),
    );

    return true;
  }
}
